import { ListItem, Link, Tooltip } from "@mui/material";
import Icons from "../../icons";
import IconButton from "../../toolkit/IconButton";
import { NavLink as RouterLink } from "react-router-dom";
import baseTheme from "../../themes/baseTheme";
import { styled } from "@mui/material";
import { getisEmp } from "../../utils/Token";

const StyledTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))`
  & .MuiTooltip-tooltip {
    background:  rgba(97, 97, 97, 0.92)!important;
    color:#fff !important
  }
     & .MuiTooltip-arrow: {
    color: rgba(97, 97, 97, 0.92)!important;
  }
`;
export default function SideMenuItem({ item, activeItem, onClick }) {

  return (
    <Tooltip title={(getisEmp() == "true" && item.actionName == "EmployeeQuizzes") ? "Dashboard" : item.menuDisplayname} placement="right" arrow sx={{ backgroundColor: "white !important", color: "#000 !important" }}>
      <ListItem
        disableGutters
        sx={{
          justifyContent: "center",
        }}
        hidden={item.menuDisplayname == ""}
      >
        <Link
          component={RouterLink}
          to={`/${item.actionName}`}
          underline="none"
          style={({ isActive }) =>
            isActive ? { backgroundColor: baseTheme.palette.grey[0] } : undefined
          }
        >

          <IconButton
            Icon={Icons[item.icon]}
            active={item.menuName === activeItem}
            onClick={onClick}
          />

        </Link>
      </ListItem>
    </Tooltip>
  );
}
